import { render, staticRenderFns } from "./CorporateInfo.vue?vue&type=template&id=10d65e38&scoped=true&"
import script from "./CorporateInfo.vue?vue&type=script&lang=js&"
export * from "./CorporateInfo.vue?vue&type=script&lang=js&"
import style0 from "./CorporateInfo.vue?vue&type=style&index=0&id=10d65e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d65e38",
  null
  
)

export default component.exports